import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://tubescript-ai-backend-production.up.railway.app';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

// Add JWT token to every request
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    const publicRoutes = ['/auth/login', '/auth/register', '/auth/forgot-password', '/auth/reset-password'];
    const isPublicRoute = publicRoutes.some(route => config.url?.includes(route));
    
    if (token && !isPublicRoute) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});
// api.interceptors.request.use((config) => {
//     const token = localStorage.getItem('token');
//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
// });

// Handle 401 errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;


// import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'tubescript-ai-backend-production.up.railway.app';

// const api = axios.create({
//     baseURL: API_BASE_URL,
//     headers: {
//         'Content-Type': 'application/json',
//     },
//     withCredentials: true, // Send cookies with every request
// });

// // Handle 401 errors
// api.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         if (error.response?.status === 401) {
//             window.location.href = '/login';
//         }
//         return Promise.reject(error);
//     }
// );

// export default api;

